import {memo, useEffect} from 'react';

import {setToken} from '../utils/auth';
import {readAuthCallback} from '../utils/auth-callback';

function Auth() {
  useEffect(() => {
    const callback = readAuthCallback(window.location.href, window.location.origin);
    if (!callback.token) return;

    // Drop the bearer token from the visible URL and from history before any
    // later request can carry it as a referrer.
    window.history.replaceState(window.history.state, '', callback.cleanUrl);

    setToken(callback.token);
    window.location.replace(callback.redirectUrl);
  }, []);

  return null;
}

export const AuthPage = memo(Auth);
